import React, { useEffect, useState, useRef } from "react";
import Select from 'react-select';

const SelectBox2 = ({ label, placeholder, name, options, value, onChange, error, setFormErrors = false, transparentBorder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  let customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '10px',
      borderColor: transparentBorder ? "transparent" : "#C1CFEF",
      width: '100%',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#C1CFEF' : 'white',
      color: '#102048',
      '&:hover': {
        backgroundColor: '#C1CFEF',
      },
    }),
  };
  const optionsMapped = [
    { value: "", label: "Select Table" },
    ...options.map((table) => ({
      value: table.id,
      label: table.table_name,
    })),
  ]

  let selectedOption = { label: placeholder, value: "" };
  if (value && optionsMapped?.length > 0) {
    const matchedOption = optionsMapped.find((option) => option.value === value);
    if (matchedOption) {
      selectedOption = matchedOption;
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="w-full relative">
      {console.log("VALUE in select2..... ",value)}
      <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] px-1 bg-white font-semibold">
        {label}
      </label>
      <Select
        name={name}
        options={optionsMapped}  // ✅ use the full list of options
        value={selectedOption}
        onChange={onChange}
        styles={customStyles}
        placeholder={placeholder}
        isSearchable
        className={`select w-full text-[#102048] font-normal placeholder:text-[#91919F] bg-transparent outline-none px-[0px]  text-sm focus:outline-none ${
          error ? " border-1 border-red-500" : ""
        }`}
      />
      {error && <div className="text-red-500 text-sm mt-1">{error}</div>}
    </div>
  );
};

export default SelectBox2;
